module.exports = __webpack_public_path__ + "static/media/Fetner.e232b2f7.jpg";